import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { CacheService } from '../../core/cache';
import { StatsApiService } from '../../core/stats';
import { AppDialogModule } from '../dialog';
import { PurgeCacheComponent } from './purge-cache-card.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    GalaxySnackbarModule,
    AppDialogModule,
  ],
  declarations: [PurgeCacheComponent],
  exports: [PurgeCacheComponent],
  providers: [CacheService, StatsApiService],
})
export class CacheModule {}
